import { Observable } from 'rxjs'
import { Injectable } from '@angular/core'

export interface UnsavedChanges {
  unsavedChanges: () => Observable<boolean> | Promise<boolean> | boolean
}

@Injectable()
export class UnsavedChangesGuard {
  canDeactivate(component: UnsavedChanges): boolean {
    if (component.unsavedChanges()) {
      if (confirm('You have unsaved changes! If you leave, your changes will be lost.')) {
        return true
      } else {
        return false
      }
    }
    return true
  }
}
